import { ReactNode } from 'react'
import { useQuery } from '@apollo/client/react'
import Link from 'next/link'
// Components
import Button from '@/components/newButton/Button'
import Loader from '@/components/newLoader/Loader'
import BreedPreview from '@/components/breedPreview'
// Utils
import { GET_BREEDS_QUIZ } from '@graphql'
import { IGetBreedQuiz } from '@types'

import styles from './puppyQuizResult.module.scss'

type PuppyQuizResultType = {
  data: {
    hasOwnedDog: boolean
    liveQuarters: string
    dogSize: string
    allergic: boolean
    kidFriendly: boolean
    timeSpent: string
    energeticLevel: string
  }
  onRetake: () => void
  children?: ReactNode
}

export default function PuppyQuizResult({
  data: { hasOwnedDog, liveQuarters, dogSize, allergic, kidFriendly, timeSpent, energeticLevel },
  onRetake,
  children,
}: PuppyQuizResultType) {
  const { loading, data } = useQuery<IGetBreedQuiz>(GET_BREEDS_QUIZ, {
    variables: {
      quiz: {
        hasOwnedDog,
        liveQuarters,
        dogSize,
        allergic,
        kidFriendly,
        timeSpent,
        energeticLevel,
      },
    },
  })

  if (loading) {
    return (
      <div className={styles.loadingContent}>
        <Loader theme="tall" />
        <div>Fetching your results</div>
      </div>
    )
  } else if (data.quiz === null) {
    return (
      <div className={styles.empty}>
        <div className={styles.blob}>
          <img className={styles.icon} src="/wand@2x.png" alt="wand icon" />
        </div>
        <div className={styles.title}>No Quiz Result Yet!</div>
        <div className={styles.subtitle}>
          Take our Puppy Matcher Quiz and we'll find you puppies to explore
        </div>
        <Link href="/dog-breed-quiz" legacyBehavior>
          <Button theme={['large', 'pink-solid']} title="Take Puppy Quiz" />
        </Link>
      </div>
    )
  } else {
    return (
      <>
        {children}
        <div className={styles.content}>
          <div className={styles.results}>
            <div className={styles.resultGrid}>
              {data.quiz &&
                data.quiz
                  .slice(0, 10)
                  // .filter((dog) => dog.isAvailable)
                  .map((breed, index) => (
                    <BreedPreview key={breed.id} breed={breed} number={index} />
                  ))}
            </div>
            <div className={styles.resultHeader}>
              <Button
                title="Retake quiz"
                onClick={() => onRetake && onRetake()}
                theme={['medium', 'pink-solid']}
              />
            </div>
          </div>
        </div>
      </>
    )
  }
}
